import React from 'react';
import { Browser } from '@capacitor/browser';
import { IonList, IonItem, IonLabel, IonNote } from '@ionic/react';
import { PageLayout } from 'containers/layout';
import pkg from '../../package.json';

const LINKS = [
  {
    text: 'Terms & Conditions',
    url: 'https://www.vemospay.com/terms--conditions.html',
  },
  {
    text: 'Privacy Policy',
    url: 'https://www.vemospay.com/privacy-policy.html',
  },
  {
    text: 'Security Statement',
    url: 'https://www.vemospay.com/security.html',
  },
];

function AboutPage() {
  const openBrowser = (url) => {
    Browser.open({ url });
  };

  return (
    <PageLayout title="About">
      <IonList>
        {LINKS.map((link) => (
          <IonItem key={link.text} onClick={() => openBrowser(link.url)}>
            <IonLabel>
              <h2>{link.text}</h2>
            </IonLabel>
          </IonItem>
        ))}
        <IonItem>
          <IonLabel>Version</IonLabel>
          <IonNote slot="end">{pkg.version}</IonNote>
        </IonItem>
      </IonList>
    </PageLayout>
  );
}

export default AboutPage;
